//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import StockAdjustCreateView from '@/views/Warehouse/WhStockAdjust/create'
import StockAdjustListView from '@/views/Warehouse/WhStockAdjust/list'
import StockAdjustUpdateView from '@/views/Warehouse/WhStockAdjust/update'

//
export default {
    path: 'stock_adjusts',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'stock-adjust',
            component: StockAdjustListView,
        },
        {
            path: 'create',
            name: 'stock-adjust-create',
            component: StockAdjustCreateView,
            meta: {
                title: 'Crear ajuste de stock',
            },
        },
        {
            path: ':id',
            name: 'stock-adjust-update',
            component: StockAdjustUpdateView,
            meta: {
                title: 'Datos de ajuste de stock',
            },
        },
    ],
    meta: {
        title: 'Ajustes de stock',
    },
}
